import { InjectionToken } from '@angular/core';

export const TASK_MYSID_TOKEN = new InjectionToken<string>('TASK_MYSID_TOKEN');
